// extracted by mini-css-extract-plugin
export default {"header":"TableHeader_header__ZQCJp"};